import { FC, useState } from 'react'
import { Button, FetchState, TextArea, useModal } from '../../../../../../components'

export const TokenModal: FC = () => {
  const { fetchStates } = useModal()

  const { data: accessToken } = (fetchStates['accessToken'] || {}) as FetchState<string>

  const [copied, setCopied] = useState<boolean>(false)

  const handleCopyToken = () => {
    navigator.clipboard.writeText(accessToken || '')
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  return (
    <div>
      <TextArea readOnly value={accessToken || ''} disabled={true} rows={4} />
      {copied && <p className='text-success mt-2'>Link copiado com sucesso</p>}
      <div className='d-flex justify-content-end mt-3'>
        <Button className='btn-secondary ' onClick={handleCopyToken}>
          Copiar
        </Button>
      </div>
    </div>
  )
}
